import React from 'react';
import { useHistory } from 'react-router-dom';
import { LandingContent } from 'components/LandingContent';
import landingImage from 'assets/images/account_setup.jpg';
import './styles.scss';

const CanceledLanding = ({ isChurned = false }) => {
  const history = useHistory();
  const goToBilling = () => {
    history.push('/app/v2/account/billing');
  };

  const title = isChurned ? 'UPDATE PAYMENT INFORMATION' : 'RE-SUBSCRIBE TODAY';

  const landContent = () => {
    if (isChurned) {
      return (
        <>
          Your subscription has been placed on hold because we haven't been able to process your payment.
          Please update your payment information to continue using Aisle Planner.
        </>
      );
    }
    return (
      <>
        Your subscription has been canceled. If you’d like to reactivate your account,
        please click the button below.
      </>
    );
  };

  return (
    <div className="content-container">
      <LandingContent
        action={goToBilling}
        title="Account On Hold"
        description={landContent()}
        actionButtonTitle={title}
        heroImage={landingImage}
        className="delinquent-landing"
      />
    </div>
  );
};

export default CanceledLanding;
